<template>
    <AppPageDrawer v-if="getDrawerAppPage.origin === 'accountAlerts'"
                   :data="allAccountAlerts"
                   title="Alerts"
                   subtitle="Select Alerts"
                   @dispatch-save="setSelectedAccountAlerts"
                   @dispatch-close-drawer="closeAccountAlertsDrawer">
        <template v-slot:item="{item}">
            <input v-model="accountAlertsSelected"
                   type="checkbox"
                   :id="item.id"
                   :value="item">
            <label :for="item.id"> {{ item.name }} </label>
        </template>
    </AppPageDrawer>
</template>

<script>
    import {list} from "@/services/account-alert";
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import AppPageDrawer from "@/pages/apps-system/detail/app-page-drawers";

    export default {
        name: "AccountAlertsDrawer",
        components: {AppPageDrawer},
        computed: {
            ...mapGetters(['getDrawerAppPage', 'getConstants']),
        },
        data() {
            return {
                allAccountAlerts: [],
                accountAlertsSelected: [],
            }
        },
        mounted() {
            this.$store.watch(state => state.drawerAppPage, async (value) => {
                if (value.origin === 'accountAlerts' && value.show === true) {
                    await this.loadAccountAlerts();
                }
            }, {deep: true});
        },
        methods: {
            closeAccountAlertsDrawer() {
                this.allAccountAlerts = [];
                this.accountAlertsSelected = [];
                _.set(this.getDrawerAppPage, 'data', {
                    itemsSelected: []
                })
                _.set(this.getDrawerAppPage, 'show', false);
            },
            setSelectedAccountAlerts() {
                _.set(this.getDrawerAppPage, 'result', this.accountAlertsSelected);
                this.closeAccountAlertsDrawer()
            },
            async loadAccountAlerts() {
                let response;
                try {
                    response = await list(this.getDrawerAppPage.data.account.network);
                } catch (e) {
                    return;
                }
                if (response.data.status === this.getConstants.RESPONSE_CODES.RESPONSE_CODE_ERROR) {
                    this.$toast.open({
                        message: 'Error recovering user details',
                        type: 'error',
                        position: 'top-right',
                        duration: 2000,
                    });
                    return;
                }
                _.forEach(response.data.result, accountAlert => {
                    if (!_.includes(this.getDrawerAppPage.data.itemsSelected, accountAlert.id)) {
                        this.allAccountAlerts.push(accountAlert);
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>